import AdminEleven from "@/layouts/AdminEleven.vue";

export const producersRoutes = [
  {
    path: "/produtores",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "producers",
        path: "",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/Producers.vue"
          ),
        meta: {
          title: "Produtores",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "producersSettings",
        path: "produtor/:type/:aba/:id",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/ProducersSettings.vue"
          ),
        meta: {
          title: "Produtores",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "segments",
        path: "/segmentos",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/Segments.vue"
          ),
        meta: {
          title: "Segmentos",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "paymentMethods",
        path: "/regra-pagamento",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/paymentMethods/PaymentMethods.vue"
          ),
        meta: {
          title: "Formas de Pagamento",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "integrations",
        path: "/integracoes",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/Integrations.vue"
          ),
        meta: {
          title: "Integrações",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "consumers",
        path: "/consumidores",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/consumer/Consumers.vue"
          ),
        meta: {
          title: "Consumidor",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "consumersSettings",
        path: "/consumidores/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/consumer/ConsumersSettings.vue"
          ),
        meta: {
          title: "Consumidor",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "producersUsers",
        path: "/usuarios",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/users/Users.vue"
          ),
        meta: {
          title: "Usuários",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "producersUserSettings",
        path: "/usuarios/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/users/UsersSettings.vue"
          ),
        meta: {
          title: "Usuários",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "produtoresProfiles",
        path: "/perfis",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/profiles/Profiles.vue"
          ),
        meta: {
          title: "Perfís",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "producersProfileSettings",
        path: "/perfis/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/producers/profiles/ProfilesSettings.vue"
          ),
        meta: {
          title: "Perfís",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];
